import type { Maybe } from '@adornis/base/utilTypes.js';
import { Float } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import { DateTime } from 'luxon';

@Entity()
export class PlanIOTicket extends MongoEntity {
  static override _class = 'PlanIOTicket';
  static override _collectionName = 'planio-tickets';

  @Field(() => Float)
  ticketID: Maybe<number>;

  @Field(() => String)
  subject: Maybe<string>;

  @Field(() => String)
  description: Maybe<string>;

  @Field(() => String)
  project: Maybe<string>;

  @Field(() => String)
  author: Maybe<string>;

  @Field(() => DateTime)
  sprint: Maybe<DateTime>;

  parseDescription(): {
    wer: string;
    was: string;
    warum: string;
  } {
    const trimSpecialChars = (str: string) => str.replace(/^[^a-zA-Z0-9äöüÄÖÜß]+/, '').trim();
    const desc = (this.description ?? '').split('\n');
    const data = {
      wer: 'Format ungenügend',
      was: 'Format ungenügend',
      warum: 'Format ungenügend',
    };

    desc.forEach(line => {
      const werMatch = line.match(/(?:^|[^a-zA-Z])(wer)(?:[^a-zA-Z]|$)/i);
      const wasMatch = line.match(/(?:^|[^a-zA-Z])(was)(?:[^a-zA-Z]|$)/i);
      const warumMatch = line.match(/(?:^|[^a-zA-Z])(warum|wieso)(?:[^a-zA-Z]|$)/i);

      console.log(line, werMatch?.[0], wasMatch?.[0], warumMatch?.[0]);

      if (werMatch && werMatch.index !== undefined && werMatch.index < 14) {
        data.wer = trimSpecialChars(line.slice(werMatch.index + werMatch[0].length));
      } else if (wasMatch && wasMatch.index !== undefined && wasMatch.index < 14) {
        data.was = trimSpecialChars(line.slice(wasMatch.index + wasMatch[0].length));
      } else if (warumMatch && warumMatch.index !== undefined && warumMatch.index < 14) {
        data.warum = trimSpecialChars(line.slice(warumMatch.index + warumMatch[0].length));
      }
    });

    return data;
  }
}
